type StyleType = "currency" | "decimal" | "percent" | "unit";
type NotationType = "compact" | "standard" | "scientific" | "engineering";

const style: StyleType = "currency";
const notation: NotationType = "compact";

export interface CurrencyFormatOptions {
  maximumFractionDigits: number;
  minimumFractionDigits: number;
  style: StyleType;
  notation: NotationType;
}

export const currencyOptions: CurrencyFormatOptions = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style,
  notation,
};
